<template>
  <div class="box">
    <ApexChart
      width="99%"
      height="265"
      type="bar"
      :options="chartOptions"
      :series="salesItemsSeries"
    />
    <BLoading
      :active.sync="loading"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('statistics');

const colorPalette = ['#00D8B6', '#008FFB', '#FEB019', '#FF4560', '#775DD0'];

const genChartOptions = labels => ({
  chart: { id: 'DashboardStatisticsItemSales', stacked: true },
  plotOptions: {
    bar: {
      columnWidth: '45%',
    },
  },
  colors: colorPalette,
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    type: 'dateTime',
  },
  yaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      style: {
        color: '#78909c',
      },
    },
  },
  title: {
    text: 'Articulos Vendidos en la Semana',
    align: 'left',
    style: {
      fontSize: '18px',
    },
  },
  labels,
});

export default {
  name: 'DashboardStatisticsSalesItems',
  data() { return { loading: false }; },
  computed: merge(
    mapState({ sales: ({ salesItems }) => salesItems }),
    mapGetters([
      'salesItemsLabels',
      'salesItemsSeries',
    ]),
    {
      chartOptions() {
        return genChartOptions(this.salesItemsLabels);
      },
    },
  ),
  async beforeMount() {
    this.loading = true;

    await this.getItemSales();

    this.loading = false;
  },
  methods: mapActions(['getItemSales']),
};
</script>

<style scoped>
</style>
